export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Index.vue?vue&type=template&id=58e032a7&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/QuatationsSupplies/Index.vue?vue&type=template&id=58e032a7&scoped=true
// module id = 2405
// module chunks = 31